<script>
import { ValidationObserver } from 'vee-validate'
import { appConfig } from '@src/app.config'
import axios from 'axios'
import { services } from '@src/utils/common-services'

// import EventBus from '@src/state/EventBus'
/* idle time calculation   */
// var time = null
// var myInterval = null
var IDLE_TIMEOUT = 10 // seconds
var _idleSecondsTimer = null
var _idleSecondsCounter = 0
var isFormChanged = false
/*
const confirmUserToLeave = function(parent) {
  window.onbeforeunload = function(e) {
    if (isFormChanged) {
      // Cancel the event
      //  e.preventDefault()
      parent.autoSaveData()
      // Chrome requires returnValue to be set
      //  e.returnValue = ''
    }
  }
} */

const autoSave = function(parent) {
  //   console.log('in autosave')

  document.onclick = function() {
    _idleSecondsCounter = 0
  }

  document.onmousemove = function() {
    _idleSecondsCounter = 0
  }

  document.onkeypress = function() {
    _idleSecondsCounter = 0
  }

  _idleSecondsTimer = window.setInterval(CheckIdleTime, 1000)

  function CheckIdleTime() {
    _idleSecondsCounter++

    if (_idleSecondsCounter >= IDLE_TIMEOUT) {
      //     console.log(_idleSecondsCounter)
      _idleSecondsCounter = 0
      if (isFormChanged) parent.autoSaveData()
    }
  }
}
export default {
  components: { ValidationObserver },
  props: {
    form: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    next: {
      default() {
        return null
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    previous: {
      default() {
        return null
      },
    },

    options: {
      type: Object,
      default() {
        return {}
      },
    },
    api: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    user: {
      type: String,
      required: true,
    },

    // eslint-disable-next-line vue/require-prop-types
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ErrorList: [
        { code: 400, content: 'Your request is invalid' },
        { code: 401, content: 'Unauthorized user. Please login' },
        {
          code: 403,
          content: 'You have no permission to view the requested content',
        },
        {
          code: 404,
          content:
            'The content or action you are requested is currently unavailable. Please refresh to get the latest data',
        },
        { code: 408, content: 'Your request is timeout' },
        {
          code: 500,
          content:
            'The content was not saved due to one or more invalid data entered. Please check the details or contact the support team for assistance.',
        },
        {
          code: 502,
          content:
            'Something went wrong with the request. Please refresh and try again',
        },
        {
          code: 503,
          content: 'The server is under maitenance. Please try again later ',
        },
        { code: 504, content: 'The server gateway timeout ' },
      ],
      formStatus: 0,
      loader: false,
      savedData: {},
      formapi: appConfig.formsUrl,
      timer: 0,
      timerStart: false,
      storeData: {},
      dataSaved: true,
      loading: false,
      id: null,
      fileData: {},
      time: null,
      files: false,
      removedHide: {},
      submitData: false,
      lostInternet: false,
      profileUser: {},
      count: 0,
      min: 0,
      sec: 0,
      hide: {},
      totalSeconds: 0,
      showSuccess: false,
      message: null,
      haveSavedData: false,
      updateLoader: false,
    }
  },

  created() {
    autoSave(this)
    //   confirmUserToLeave(this)
  },
  beforeDestroy() {
    //   console.log('destroyed')
    clearInterval(this.time)
    window.clearInterval(_idleSecondsTimer)
    this.hide.length = 0
    this.removedHide.length = 0
    this.count = 0
    this.$off('update')
    this.$off('image')
    this.$off('data')
    this.$off('base')
    this.$off('emit')
    this.$off('dependency')
    this.$off('delete')
    this.$root.$off('deleteFile')
    this.$root.$off('hide')
    this.$root.$off('removedHide')
    this.$root.$off('callAutoSave')
    //  var doc = this.$refs.formbody
    // if (doc !== undefined) doc.innerHTML = ''
    // console.log('destroyed')
    // remove the element from the DOM
    // if (this.$el.parentNode !== null) this.$el.parentNode.removeChild(this.$el)
    //    this.$destroy();
  },
  beforeMount() {
    //   console.log(appConfig.formsUrl)
    this.getUser()
  },
  mounted() {
    this.$root.$on('deleteFile', (data) => {
      this.deleteFile(data)
    })
    this.$root.$on('hide', (data) => {
      this.hide[data.name] = data.count
      // this.$set(this.hide,data.name,data.count)
    })
    this.$root.$on('removedHide', (data) => {
      this.removedHide[data.name] = data.count
    })
    this.$root.$on('callAutoSave', (data) => {
      if (data.status) {
        if (data.data !== undefined)
          this.saveData(data.data.name, false, false, true)
        else this.saveData(null, false, false, true)
      }
    })
  },
  methods: {
    clearClockAndSet() {
      // clearInterval(this.time)
      //  window.clearInterval(myInterval)
      //    window.clearInterval(_idleSecondsTimer)

      this.totalSeconds = 0
      //  autoSave(this)

      //   this.setSavedTime()
    },
    deleteFile(id) {
      axios
        .delete(this.formapi + '/document/' + id, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'JWT ' + services.getAuth(),
          },
        })
        .then((response) => {})
        .catch((error) => {
          if (error) {
          }
        })
      var parent = this
      setTimeout(() => {
        parent.autoSaveData()
      }, 3000)
    },
    getUser() {
      // this.loading=true
      this.profileUser = services.decodeJWT(services.getAuth())
      //  console.log(this.profileUser)
      if (!services.authorized()) this.getData()
      else
        this.$router.push(
          this.$route.query.redirectFrom || { name: 'session-out' }
        )
      //  console.log(this.profileUser)
    },
    getSum(obj) {
      //   console.log(obj)
      var sum = 0
      if (Object.keys(obj).length > 0)
        for (var el in obj) {
          if (obj.hasOwnProperty(el)) {
            sum += parseFloat(obj[el])
          }
        }

      return sum
    },
    showErrorToaster(data) {
      //  console.log(data.response)
      // this.showError = false
      this.message = []

      if (data.response !== undefined && data.response.data !== undefined) {
        var obj = this.ErrorList.find(
          (x) => x.code === data.response.data.status
        )
        let index = this.ErrorList.indexOf(obj)

        //  var added =
        //    data.name !== '' ? ' Regarding the form ' + data.name : ''
        //  this.ErrorList[index]
        if (index >= 0) {
          if (this.ErrorList[index].code === 500)
            this.message = this.ErrorList[index].content
          else {
            this.message =
              this.ErrorList[index].content +
              data.response.data.message.errors[0].detail
          }
        } else {
          this.message = 'Something went wrong. Please refresh your page'
        }
        this.showSuccess = false
        this.$bvToast.show('formToasterError')
        this.$bvToast.hide('noInternet')
        this.lostInternet = false
        var parent = this
        setTimeout(() => {
          parent.$bvToast.hide('formToasterError')
        }, 6000)
      } else {
        //  console.log(data)
        this.message =
          'Something went wrong.Please check your internet connection'

        if (!this.lostInternet) {
          this.lostInternet = true
          this.$bvToast.show('noInternet')
        }
      }
    },

    getDataCount() {
      this.getTotalFieldCount()
      // let hiddenvalue = this.getSum(this.hide)
      //     let removedHiddenValue = this.getSum(this.removedHide)
      // let nullCount = 0
      // let availData = 0
      if (Object.keys(this.storeData).length > 0) {
        if (Object.keys(this.storeData).length < this.count) return 0
        else {
          // console.log(Object.keys(this.storeData).length)
          return 1
        }
      } else {
        return 0
      }
    },

    getDataCounts() {
      this.getTotalFieldCount()
      //   var preStatus = this.formStatus
      //   console.log(preStatus)
      let nullCount = 0

      let availData = 0
      //   console.log(this.hide)
      //   console.log(this.removedHide)
      let hiddenvalue = this.getSum(this.hide)
      let removedHiddenValue = this.getSum(this.removedHide)
      //   console.log('hidden' + hiddenvalue)
      //  console.log('count' + this.count)
      //   console.log('remove' + removedHiddenValue)
      //   var total=this.count+hiddenvalue
      if (Object.keys(this.storeData).length > 0) {
        for (const item in this.storeData) {
          if (
            this.storeData[item] === null ||
            this.storeData[item] === '' ||
            this.storeData[item].length === 0
          ) {
            //    console.log(item)
            if (item !== 'homeNumber') nullCount++
          } else {
            if (item !== 'formStatus' && item !== 'homeNumber') availData++
          }
        }
        if (nullCount > 0) {
          //     console.log(nullCount)
          //  let checkHide = nullCount - removedHiddenValue
          //  availData=availData+removedHiddenValue
          //  console.log(checkHide)
          /*   if (checkHide > 0) {
            return 0
          }
          //  console.log('not Complete have null value')
          else { */
          //  console.log('filled data '+availData)
          //      console.log(this.count + '>' + availData)
          /* console.log(this.count)
console.log(availData) */
          if (this.count > availData) {
            return 0
          } else {
            //  var flag = 0

            //    console.log(hiddenvalue + '-' + removedHiddenValue)
            if (hiddenvalue - removedHiddenValue > 0) {
              var checks = 0
              for (var hideKey in this.hide) {
                //   for (var keys in this.storeData) {

                if (this.removedHide[hideKey] === 0) {
                  if (this.storeData[hideKey] === null) {
                    checks++
                  }
                }
                /*  if (hideKey === keys) {
                      //      console.log(hideKey)
                      flag++
                    } */
                //    }
              }
              //    console.log('checks ' + checks)
              if (checks > 0) {
                return 0
              } else {
                // console.log(flag + '=' + hiddenvalue)
                /*  console.log(removedHiddenValue)
                  console.log(this.hide)
                  console.log(this.removedHide) */

                if (hiddenvalue > removedHiddenValue) {
                  //  console.log('here')
                  if (this.checkEntry()) return 0
                  else return 1
                } else return 0
              }
            } else return 1
          }
        } //
        else {
          //  console.log('filled data ' + availData)
          //    console.log('count'+ this.count)
          if (this.count > availData) {
            return 0
          } else {
            //    var flags = 0
            //    console.log(hiddenvalue - removedHiddenValue)
            if (hiddenvalue - removedHiddenValue > 0) {
              var checking = 0
              //  for (var storeKey in this.storeData) {
              for (var hiddenKeys in this.hide) {
                if (this.removedHide[hiddenKeys] === 0)
                  if (this.storeData[hiddenKeys] === null) {
                    checking++
                  }
                /*   if (hiddenKeys === storeKey) {
                       console.log(hiddenKeys)
                    flags++
                  } */
                // }
              }
              if (checking > 0) return 0
              else {
                if (hiddenvalue > removedHiddenValue)
                  if (this.checkEntry()) return 0
                  else return 1
                else return 0
              }
            } else return 1
          }
        }
      }
    },
    getTotalFieldCount() {
      //   console.log(this.form[0].form.length)
      var form = this.form[0].form
      this.count = 0
      for (var i = 0; i < form.length; i++) {
        //   console.log(form[i].typeComponent)
        if (
          form[i].typeComponent !== 'FormBaseNote' &&
          form[i].typeComponent !== 'FormBaseHideShow' &&
          form[i] !== length
        )
          this.count++
        //    console.log(form[i].name)
        if (form[i].name === 'homeNumber') this.count--
      }
    },
    checkEntry() {
      var check = 0
      for (var i = 0; i < this.form[0].form.length; i++) {
        if (
          this.form[0].form[i].typeComponent !== 'FormBaseHideShow' &&
          this.form[0].form[i].typeComponent !== 'FormBaseNote' &&
          this.form[0].form[i].name !== 'homeNumber'
        ) {
          if (
            this.storeData[this.form[0].form[i].value] === undefined ||
            this.storeData[this.form[0].form[i].value] === null ||
            this.storeData[this.form[0].form[i].value] === ''
          )
            check++
        }
      }
      return check
    },

    autoSaveData() {
      //       console.log(this.dataSaved)
      if (!this.dataSaved) this.saveData(null, false, false)
    },

    setSavedTime() {
      // console.log('in savedTime'+time)
      this.timerStart = true
      this.time = setInterval(this.setTime, 1000)
    },
    setTime() {
      this.timer++
      if (this.timer === 5) {
        clearInterval(this.time)

        this.totalSeconds = this.totalSeconds + this.timer
        //     console.log('totalSec'+this.totalSeconds)
        this.sec = this.totalSeconds % 60
        this.min = parseInt(this.totalSeconds / 60)
        this.timer = 0
        this.setSavedTime()
      }
    },
    pad(val) {
      var valString = val + ''
      if (valString.length < 2) {
        return '0' + valString
      } else {
        return valString
      }
    },
    deleteData(event) {
      this.storeData[event.name] = event.data
      this.dataSaved = false
      this.saveData(null, false, false, false)
    },
    editData(event) {
      //       console.log(event)
      //    console.log(this.totalSeconds)
      if (!this.timerStart) this.setSavedTime()
      this.storeData[event.name] = event.data
      this.dataSaved = false
      isFormChanged = true
      this.$root.$emit('savedData', this.dataSaved)
    },
    updateData(event) {
      //    console.log(event)
      //   console.log(this.totalSeconds)
      if (!this.timerStart) this.setSavedTime()
      if (event.data !== null) {
        this.storeData[event.name] = event.data
      } else this.storeData[event.name] = event.data
      isFormChanged = true
      this.dataSaved = false
      this.$root.$emit('savedData', this.dataSaved)
      //   this.$emit('update', { name: name, data: event })
      /*  console.log(this.storeData)
       console.log(this.fileData) */
    },

    getData() {
      clearInterval(this.time)
      this.loading = true
      //  window.clearInterval(myInterval)
      this.hide.length = 0
      this.removedHide.length = 0
      this.count = 0
      axios
        .get(this.formapi + this.api + this.user, {
          headers: { Authorization: 'JWT ' + services.getAuth() },
        })
        .then((response) => {
          this.storeData = response.data.attributes

          this.formStatus =
            this.storeData.formStatus !== undefined
              ? this.storeData.formStatus
              : 0
          this.haveSavedData = true
          let formStatus = {}
          formStatus['name'] = this.value
          formStatus['user'] = this.user
          formStatus['status'] = this.formStatus
          this.$root.$emit('formStatus', formStatus)
          this.$root.$emit('savedData', true)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$root.$emit('savedData', true)
          if (error) {
            if (error.response === undefined || error.response.status !== 404) {
              this.message =
                'Please refresh the page or check your connectivity. If this is a repeating message, please feel free to contact our technical team for further assistance.'
              this.showSuccess = false
              this.$bvToast.show('formToaster')
            }
            var parent = this
            setTimeout(() => {
              parent.$bvToast.hide('formToaster')
              parent.message = ''
            }, 5000)
          }
        })
    },
    postData(api, to, show, formStat) {
      var callSubmit = false
      if (
        !this.profileUser.is_Staff &&
        this.next === null &&
        this.profileUser.applicant_type === 'applicant1' &&
        this.submitData
      )
        callSubmit = true
      if (show) this.updateLoader = true

      var data = {
        applicantId: this.user,
        attributes: this.storeData,
      }
      axios
        .post(api + this.user, data, {
          headers: { Authorization: 'JWT ' + services.getAuth() },
        })
        .then((response) => {
          if (to !== null) this.$root.$emit('formLoader', true)
          this.haveSavedData = true
          this.updateLoader = false
          this.message = 'Your data is successfully added'
          if (show) this.$bvToast.show('formToaster')
          this.showSuccess = true
          var parent = this
          isFormChanged = false
          this.dataSaved = true
          this.$root.$emit('savedData', this.dataSaved)

          this.totalSeconds = 0
          this.$root.$emit('formStatus', formStat)
          if (callSubmit) this.$root.$emit('submitForm', true)
          // this.clearClockAndSet()
          setTimeout(() => {
            parent.$bvToast.hide('formToaster')

            this.loader = false
            if (to !== null) {
              parent.$root.$emit('click', { name: to, show: false })
              parent.$root.$emit('formLoader', false)
            }
            parent.message = null
          }, 4000)
        })
        .catch((error) => {
          if (error) {
            //  console.log(error)
            this.showErrorToaster(error)
            this.$root.$emit('formLoader', false)

            this.updateLoader = false
          }
        })
      /*  this.send({
        to: api,
        data: {
          type: this.api.type,
          attributes: this.storeData,
        },
        state: 'post',
      })
        .then((token) => {
          if (token.data !== undefined) {
            //    console.log(token.data)
            this.id = token.data.id
            this.$root.$emit('toaster', {
              message: 'Your data is saved',
              showSuccess: true,
            })
            if (this.files) {
              if (
                this.more.fileApi !== undefined &&
                this.more.fileApi !== null
              ) {
                let fileapi = services.apiService(
                  this.more.fileApi.put,
                  this.user.id,
                  this.id
                )
                this.sendFileData(fileapi)
              }
            }
          }
        })
        .catch((error) => {
          if (error) {
          } // console.log(error)
        }) */
    },
    putData(api, to, show, formStat) {
      var callSubmit = false

      if (
        !this.profileUser.is_Staff &&
        this.next === null &&
        this.profileUser.applicant_type === 'applicant1' &&
        this.submitData
      )
        callSubmit = true
      if (show) this.updateLoader = true

      var data = {
        applicantId: this.user,
        attributes: this.storeData,
      }
      axios
        .put(api + this.user, data, {
          headers: { Authorization: 'JWT ' + services.getAuth() },
        })
        .then((response) => {
          //   this.totalSeconds = 0
          if (to !== null) this.$root.$emit('formLoader', true)
          this.message = 'Your data is successfully updated'
          if (show) this.$bvToast.show('formToaster')
          this.showSuccess = true
          var parent = this
          this.dataSaved = true
          isFormChanged = false
          this.$root.$emit('savedData', this.dataSaved)
          if (callSubmit) this.$root.$emit('submitForm', true)
          this.updateLoader = false
          this.totalSeconds = 0
          this.$root.$emit('formStatus', formStat)
          setTimeout(() => {
            //   this.clearClockAndSet()
            /*   parent.totalSeconds = 0
            parent.min = 0
            parent.sec = 0 */

            if (to !== null) {
              parent.$root.$emit('click', { name: to, show: false })
              parent.$root.$emit('formLoader', false)
            }
            parent.$bvToast.hide('formToaster')
            parent.message = null
          }, 4000)
        })
        .catch((error) => {
          if (error) {
            this.showErrorToaster(error)
            //   console.log(error)
            this.updateLoader = false
            this.$root.$emit('formLoader', false)
          }
        })
    },
    async saveData(to, show, submit, showErrorToaster) {
      if (!services.authorized()) {
        var parent = this
        this.submitData = submit
        //   console.log(JSON.stringify(this.storeData))
        let formStat = { name: this.value, user: this.user }

        if (Object.keys(this.storeData).length !== 0 && !this.dataSaved) {
          //    this.getUser()
          var currentFormstatus = await this.getDataCounts()
          //  this.removedHide = {}
          // this.hide = {}
          this.storeData['formStatus'] = currentFormstatus
          //   console.log(this.$refs.form)
          if (this.$refs.form !== undefined)
            this.$refs.form.validate().then((valid) => {
              if (valid) {
                if (!this.haveSavedData) {
                  formStat['status'] = currentFormstatus
                  this.formStatus = currentFormstatus

                  this.postData(this.formapi + this.api, to, show, formStat)
                } else {
                  formStat['status'] = currentFormstatus

                  this.formStatus = currentFormstatus

                  this.putData(this.formapi + this.api, to, show, formStat)
                }
              } else {
                this.message =
                  'There are some invalid or incomplete data in this form. Please review this form and make necessary corrections.'

                this.showSuccess = false
                if (showErrorToaster) {
                  this.$bvToast.show('formToaster')

                  setTimeout(() => {
                    parent.$bvToast.hide('formToaster')
                  }, 3000)
                }
              }
            })
        } else {
          if (to !== null) {
            this.$emit('click', { name: to, show: false })
          } else if (
            !this.profileUser.is_Staff &&
            this.next === null &&
            this.profileUser.applicant_type === 'applicant1' &&
            this.submitData
          )
            this.$root.$emit('submitForm', true)
          else if (show) {
            this.message = 'Your data is already saved or no data to commit'
            this.showSuccess = true

            this.$bvToast.show('formToaster')

            setTimeout(() => {
              parent.$bvToast.hide('formToaster')
              //  parent.message = null
            }, 4000)
          }
        }
      } else
        this.$router.push(
          this.$route.query.redirectFrom || { name: 'session-out' }
        )
    },
  },
}
</script>

<template>
  <div ref="formbody">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form
        :class="$style.formDetails"
        @submit.prevent="handleSubmit(saveData(null, true, false, true))"
      >
        <!-- <div class="clear d-xl-none d-sm-block d-md-none d-lg-none"></div> -->
        <div :class="$style.saveUser" class="pt10 pb10 mb35">
          <button
            :class="$style.backToBtn"
            class="buttonCommon FR ml15 ml0-sm"
            type="button"
            @click="saveData(null, true, false, true)"
          >
            <b-spinner
              v-if="updateLoader"
              style="width: 18px; height: 18px;"
              class="ml15 mr15"
              label="Spinning"
            ></b-spinner>
            <BIcon
              v-if="!updateLoader"
              icon="file-earmark-check"
              class="mr5"
            ></BIcon
            >{{ !updateLoader ? 'Save' : '' }}
          </button>
          <i :class="$style.autoSaveTxt" class="FL"
            ><BIcon icon="info-circle" class="mr5"></BIcon>Last saved
            {{ min }} Minute(s) {{ sec }} Seconds ago</i
          >
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
        <div v-for="(field, key) in form" :key="key">
          <div class="clear"></div>

          <component
            :is="field.typeComponent"
            :ref="field.form"
            :value="storeData"
            :form="field.form"
            :options="options"
            :name="field.name"
            :user="user"
            @update="updateData"
            @edit="editData"
            @delete="deleteData"
          />
        </div>

        <div class="clear"></div>
        <div :class="[$style.formGroup]">
          <div :class="[$style.buttonWrapper]" class=" mt30 mb30 mb70-sm">
            <button
              class="buttonCommon buttonPrimary button FR"
              type="button"
              @click="saveData(next, true, true, true)"
              v-on="$listeners"
            >
              <b-spinner
                v-if="updateLoader"
                style="width: 18px; height: 18px;"
                class="ml15 mr15"
                label="Spinning"
              ></b-spinner>
              {{
                !updateLoader
                  ? next !== null
                    ? 'Continue'
                    : !profileUser.is_Staff &&
                      profileUser.applicant_type == 'applicant1'
                    ? 'Save & Submit'
                    : 'Save'
                  : ''
              }}
            </button>
            <button
              v-if="previous !== null"
              class="buttonCommon buttonCancel button mr10 FR"
              type="button"
              v-on="$listeners"
              @click="saveData(previous, true, false, true)"
              ><b-spinner
                v-if="updateLoader"
                style="width: 18px; height: 18px;"
                class="ml15 mr15"
                label="Spinning"
              ></b-spinner>
              {{ !updateLoader ? 'Previous' : '' }}
            </button>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </form>
    </ValidationObserver>
    <div :class="$style.toasterMainWrap">
      <b-toast id="formToaster" solid no-auto-hide b-toaster-top-right>
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
    <div :class="$style.toasterMainWrap">
      <b-toast id="formToasterError" solid no-auto-hide b-toaster-top-right>
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
    <div v-if="loading" :class="$style.loader">
      <svg
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="64px"
        height="64px"
        viewBox="0 0 128 128"
        xml:space="preserve"
      >
        <g>
          <path
            d="M78.75 16.18V1.56a64.1 64.1 0 0 1 47.7 47.7H111.8a49.98 49.98 0 0 0-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0 1 47.7-47.7V16.2a49.98 49.98 0 0 0-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 0 1 1.8 78.5h14.63a49.98 49.98 0 0 0 33.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 0 1-47.7 47.7v-14.63a49.98 49.98 0 0 0 33.08-33.07z"
            fill="#ff6017"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 64 64"
            to="-90 64 64"
            dur="400ms"
            repeatCount="indefinite"
          ></animateTransform>
        </g>
      </svg>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.autoSaveTxt {
  float: right;
  margin-top: 5px;
  margin-left: 5px;
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji !important;
  font-size: 11px !important;
  color: #8c959f !important;
  svg {
    font-size: 11px !important;
  }
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.5);

  svg {
    position: fixed;
    top: calc(50vh - 32px);
    left: calc(50vw - 32px);
  }
}

.backToBtn {
  padding: 5px 14px !important;
  font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px !important;
  color: #fff !important;
  background: #ff5d16 !important;
  border-radius: 50px !important;
}

.formDetails {
  padding: 0 30px;
}

.formGroup {
  max-width: 500px;
}

.saveUser {
  border-bottom: 1px solid #ecebeb;
}
</style>
